import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { intlShape, injectIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { Icon, Label } from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import { FILTERS } from '@control-front-end/common/constants/filters';
import './MenuItem.scss';
import mes from './intl';

class MenuItem extends PureComponent {
  constructor(props) {
    super(props);
    const open = props.menuItem.open || props.open;
    this.state = {
      open,
    };
    this.isActive = this.isActive.bind(this);
    this.showSubMenu = this.showSubMenu.bind(this);
  }

  // Ф-ция локализации
  i(mesId) {
    return AppUtils.getMes(this.context)(mesId);
  }

  isActive(url, innerLinks = []) {
    const links = [url];
    innerLinks.forEach((i) => {
      links.push(this.getAccLink(i));
    });
    const findUrls = links.find((i) => document.location.href.includes(i));
    return !!findUrls;
  }

  showSubMenu() {
    this.setState({
      open: !this.state.open,
    });
  }

  getFilterParams(filterId, filterKey = '') {
    if (!FILTERS[filterId]) return {};
    const index =
      filterKey !== ''
        ? FILTERS[filterId].findIndex((filter) => filter.key === filterKey)
        : 0;
    const { filterParams } = AppUtils.getFilter(
      filterId,
      FILTERS[filterId][index].key
    );
    return filterParams || {};
  }

  getAccLink(link) {
    const { accId } = this.props;
    return link.replace('{{accId}}', accId);
  }

  isAllowedToRole(access) {
    const { role } = this.props;
    if (access === 'owner') {
      return AppUtils.isOwner(role);
    }
    if (access === 'admin') {
      return AppUtils.isAdmin(role);
    }
    return true;
  }

  renderSubMenu() {
    const { children } = this.props.menuItem;
    return children.map((item) => {
      const { id, title, access, innerLinks } = item;
      const filterParams = this.getFilterParams(item.filterId, item.filterKey);
      const link = this.getAccLink(item.link);
      const isAllowed = this.isAllowedToRole(access);
      return isAllowed ? (
        <NavLink
          key={id}
          to={`${AppUtils.makeUrl(link, { ...filterParams })}`}
          isActive={() => this.isActive(link, innerLinks)}
        >
          <div styleName="menu__row">
            <Label styleName="menu__row__label" value={this.i(mes[title])} />
          </div>
        </NavLink>
      ) : null;
    });
  }

  render() {
    const { open } = this.state;
    const { menuItem } = this.props;
    const { id, title, icon, visibility, access, children, innerLinks } =
      menuItem;
    const link = this.getAccLink(menuItem.link);
    const filterParams = this.getFilterParams(id);
    const hasSubMenu = children.length > 0;
    const accessAllowed = this.isAllowedToRole(access);
    return accessAllowed ? (
      <div styleName="menu">
        <NavLink
          to={`${AppUtils.makeUrl(link, { ...filterParams })}`}
          isActive={() => this.isActive(link, innerLinks)}
          onClick={() => {
            if (!open) this.showSubMenu();
          }}
        >
          <div styleName={cn('menu__row', { empty: !hasSubMenu })}>
            {hasSubMenu ? (
              <Icon
                styleName={cn('menu__row__icon__dropdown', { close: !open })}
                type="dropdown"
                size="micro"
                onClick={this.showSubMenu}
              />
            ) : null}
            <Icon
              styleName="menu__row__icon"
              type={icon}
              visibility={visibility}
            />
            <Label
              styleName="menu__row__label"
              visibility={visibility}
              value={this.i(mes[title])}
            />
          </div>
        </NavLink>
        {hasSubMenu && open ? (
          <div styleName="sub__menu">{this.renderSubMenu()}</div>
        ) : null}
      </div>
    ) : null;
  }
}

MenuItem.defaultProps = {
  open: false,
};

MenuItem.propTypes = {
  accId: PropTypes.string.isRequired,
  role: PropTypes.string,
  open: PropTypes.bool,
  menuItem: PropTypes.shape({
    id: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    title: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    link: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    innerLinks: PropTypes.array, // eslint-disable-line react/no-unused-prop-types
    visibility: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    icon: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    access: PropTypes.oneOf([
      // eslint-disable-line react/no-unused-prop-types
      'user',
      'admin',
      'owner',
      'clientBase.view',
      'clientBase.admin',
    ]),
    open: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
    children: PropTypes.arrayOf(
      PropTypes.shape({
        // eslint-disable-line react/no-unused-prop-types
        id: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
        title: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
        link: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
        visibility: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
      })
    ),
  }),
};

MenuItem.contextTypes = {
  intl: intlShape,
};

export default injectIntl(MenuItem);
